export default __webpack_public_path__ + "static/media/partners-10-genopets.eb716d16.png";